import React, {FC} from "react";
import classNames from "classnames";
import cls from "./shared.module.scss"
import {ArrowRoundedLeft8x13Svg, ArrowRoundedRight8x13Svg} from "../../svg";

interface IPaginationProps {
    siblings?: number,
    current: number,
    total: number,
    onPageChange: (value: number) => void,
}

const Pagination: FC<IPaginationProps> = ({
                                              current = 1,
                                              siblings = 1,
                                              total = 1,
                                              onPageChange
                                          }) => {
    const setPage = (value: number) => {
        if (value < 1 || value > total || value === current) {
            return;
        }

        try {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        } catch {
            window.scrollTo(0, 0);
        }

        if (onPageChange) {
            onPageChange(value);
        }
    };

    const getPages = () => {
        const pages = [];
        const min = Math.max(
            1,
            current - siblings - Math.max(0, siblings - total + current)
        );
        const max = Math.min(total, min + siblings * 2);

        for (let i = min; i <= max; i += 1) {
            pages.push(i);
        }
        return pages;
    }

    const firstLinkClasses = classNames(cls["page-item"], {
        [cls["page-item-disabled"]]: current <= 1,
    });

    const lastLinkClasses = classNames(cls["page-item"], {
        [cls["page-item-disabled"]]: current >= total,
    });

    const pages = getPages().map((page, index) => {
        const classes = classNames(cls["page-item"], {
            [cls["page-item-active"]]: page === current,
        });
        return (
            <li key={index} className={classes}>
                <button
                    type="button"
                    className={cls["page-link"]}
                    onClick={() => setPage(page)}
                >
                    {page}
                    {page === current && <span className={cls["sr-only"]}>{current}</span>}
                </button>
            </li>
        );
    });

    return (
        <ul className={cls["pagination"]}>
            <li className={firstLinkClasses}>
                <button
                    type="button"
                    className={`${cls["page-link"]} ${cls["page-link--with-arrow"]}`}
                    aria-label="Previous"
                    onClick={() => setPage(current - 1)}
                >
                    <ArrowRoundedLeft8x13Svg
                        className={`${cls["page-link__arrow"]} ${cls["page-link__arrow--left"]}`}
                        aria-hidden="true"
                    />
                </button>
            </li>
            {pages}
            <li className={lastLinkClasses}>
                <button
                    type="button"
                    className={`${cls["page-link"]} ${cls["page-link--with-arrow"]}`}
                    aria-label="Next"
                    onClick={() => setPage(current + 1)}
                >
                    <ArrowRoundedRight8x13Svg
                        className={`${cls["page-link__arrow"]} ${cls["page-link__arrow--right"]}`}
                        aria-hidden="true"
                    />
                </button>
            </li>
        </ul>
    );
}


export default Pagination;
